import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";

export default function BarChart({ chartdata, chartLabel }) {
  const [bgc, setBgc] = useState([]);

  useEffect(() => {
    let b = [];
    for (let i = 0; i < 120; i++) b.push("#005bff");
    for (let i = 0; i < 24; i++) b.push("#31e6af");
    console.log(b.length);
    console.log(chartdata.length);
    setBgc(b);
  }, []);

  return (
    <div>
      <Line
        height={220}
        width={350}
        data={{
          labels: chartLabel,
          datasets: [
            {
              label: "Price(Blue) with prediction(Green)",
              data: chartdata,
              backgroundColor: bgc,
              //fill: true,
            },
          ],
        }}
        options={{
          maintainAspectRatio: false,
        }}
      />
    </div>
  );
}
